import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "./Indices.css";
import { FaCheck } from "react-icons/fa";

const Indices = () => {
    useEffect(() => {
        // Prevent duplicate script insertion
        if (document.querySelector("#tradingview-widget-script")) return;

        // Create script element
        const script = document.createElement("script");
        script.id = "tradingview-widget-script"; // Unique ID to prevent duplication
        script.src = "https://s3.tradingview.com/external-embedding/embed-widget-market-overview.js";
        script.async = true;
        script.innerHTML = JSON.stringify({
            "colorTheme": "light",
            "dateRange": "12M",
            "showChart": true,
            "locale": "en",
            "largeChartUrl": "",
            "isTransparent": false,
            "showSymbolLogo": true,
            "showFloatingTooltip": false,
            "width": "1000",
            "height": "550",
            "plotLineColorGrowing": "rgba(41, 98, 255, 1)",
            "plotLineColorFalling": "rgba(41, 98, 255, 1)",
            "gridLineColor": "rgba(240, 243, 250, 0)",
            "scaleFontColor": "rgba(19, 23, 34, 1)",
            "belowLineFillColorGrowing": "rgba(41, 98, 255, 0.12)",
            "belowLineFillColorFalling": "rgba(41, 98, 255, 0.12)",
            "belowLineFillColorGrowingBottom": "rgba(41, 98, 255, 0)",
            "belowLineFillColorFallingBottom": "rgba(41, 98, 255, 0)",
            "symbolActiveColor": "rgba(41, 98, 255, 0.12)",
            "tabs": [
                {
                    "title": "Indices",
                    "symbols": [
                        { "s": "FOREXCOM:SPXUSD", "d": "S&P 500 Index" },
                        { "s": "FOREXCOM:NSXUSD", "d": "US 100 Cash CFD" },
                        { "s": "FOREXCOM:DJI", "d": "Dow Jones Industrial Average Index" },
                        { "s": "INDEX:NKY", "d": "Japan 225" },
                        { "s": "INDEX:DEU40", "d": "DAX Index" },
                        { "s": "FOREXCOM:UKXGBP", "d": "FTSE 100 Index" }
                    ],
                    "originalTitle": "Indices"
                }
            ]
        });

        // Append script to the widget container
        document.querySelector(".tradingview-widget-container").appendChild(script);
    }, []);

    return (
        <>
            <Navbar />

            <div className="forex-section">
                <h2 className="forex-title">Indices</h2>
            </div>

            <div className="below-hero-section">
                <p>
                    Indices, or stock indices, are essential financial instruments that represent the performance of a group of stocks, typically from a specific market or sector. They provide a benchmark to gauge market trends and investor sentiment. Popular examples include the S&P 500, representing 500 of the largest U.S. companies, and the FTSE 100, encompassing the 100 largest companies on the London Stock Exchange. By tracking indices, investors can gain insights into market performance and diversify their portfolios without needing to invest in individual stocks.
                </p>
            </div>

            <div className="below-hero-section2">
                <h2>Trade Indices With Us</h2>
                {/* TradingView Widget */}
                <div className="widget-wrapper">
                    <div className="tradingview-widget-container">
                        <div className="tradingview-widget-container__widget"></div>
                        <div className="tradingview-widget-copyright">
                            <a href="https://www.tradingview.com/" rel="noopener nofollow" target="_blank"></a>
                        </div>
                    </div>
                </div>
            </div>

            {/* Four-Column Section with Icons Aligned to the Right */}
            <div className="four-column-section">
                <div className="column2">
                    <div className="column-content">
                        <div className="icon-box">
                            <FaCheck className="icon" />
                        </div>
                        <div className="text">
                            <h3>High leverage, tight spreads</h3>

                        </div>
                    </div>
                </div>

                <div className="column2">
                    <div className="column-content">
                        <div className="icon-box">
                            <FaCheck className="icon" />
                        </div>
                        <div className="text">
                            <h3>Advanced charting widgets</h3>

                        </div>
                    </div>
                </div>

                <div className="column2">
                    <div className="column-content">
                        <div className="icon-box">
                            <FaCheck className="icon" />
                        </div>
                        <div className="text">
                            <h3>Responsive, easy-to-use platforms</h3>

                        </div>
                    </div>
                </div>

                <div className="column2">
                    <div className="column-content">
                        <div className="icon-box">
                            <FaCheck className="icon" />
                        </div>
                        <div className="text">
                            <h3>Smart and friendly support, 5 days a week</h3>

                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default Indices;
